export const GET_PARTNER_CONFIGS = 'src/pages/notification/GET_PARTNER_CONFIGS';
export const GET_PARTNER_CONFIGS_SUCCESS =
  'src/pages/notification/GET_PARTNER_CONFIGS_SUCCESS';
export const GET_PARTNER_CONFIGS_FAILED =
  'src/pages/notification/GET_PARTNER_CONFIGS_FAILED';
export const UPDATE_PARTNER_CONFIGS =
  'src/pages/notification/UPDATE_PARTNER_CONFIGS';
export const UPDATE_PARTNER_CONFIGS_SUCCESS =
  'src/pages/notification/UPDATE_PARTNER_CONFIGS_SUCCESS';
export const UPDATE_PARTNER_CONFIGS_FAILED =
  'src/pages/notification/UPDATE_PARTNER_CONFIGS_FAILED';
